<script>

    import { toast } from 'bulma-toast'
    import { modalStore, pickupsStore, pickupStore } from '../stores'
    
    import PickupsService from '../$services/pickups.svelte'
    
    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'
    import Select from '../$components/select.svelte'

    import ButtonModal from '../$components/button.modal.svelte'
    import ButtonSave from '../$components/button.save.svelte'

    let data = {
        status: $pickupStore.status,
        folio: $pickupStore.folio
    }

    let loading = false

    async function updatePickup() {
    
        loading = true
        const resp = await PickupsService.updatePickup($pickupStore._id, data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
        
        pickupsStore.replace(resp.data)
        pickupStore.set(resp.data)

        toast({message: 'Recolección actualizada', type: 'is-success'})
        modalStore.close()
    }

</script>

<Form on:submit={ updatePickup }  { loading }>

    <Select bind:value={ data.status } 
        label="Estatus"
        options={[
            {value: 'pending', text: 'Pendiente'},
            {value: 'success', text: 'Agendado'},
            {value: 'canceled', text: 'Cancelado'}
        ]}
    />

    <InputText bind:value={ data.folio } label="Folio" placeholder="Folio" />
        
    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <ButtonModal modalId="pickup_modal" text="Cancelar" icon="ban" />
        <ButtonSave icon="edit" text="Actualizar" { loading } />
    </div>
    
</Form>